<div class="products-view__list products-list products-list--grid--4 search-results" data-layout="grid" data-with-features="false"
    infiniteScroll  [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollUpDistance]="scrollUpDistance"
    [infiniteScrollThrottle]="throttle" 
    (scrolled)="scrollEvent()" 
    [alwaysCallback]="true">
    <div class="products-list__content">
        <app-product-search class="products-list__item" [product]="prodotto" *ngFor="let prodotto of prodotti"></app-product-search>
    </div>
</div>